<template>
  <v-navigation-drawer
    class="px-0 mx-0 ehc-nav-drawer"
    width="174px"
    clipped
    app
    overlay-color="#1D3557"
    :overlay-opacity="0.7"
    v-model="drawerShow"
  >
    <template #prepend>
      <v-list-item>
        <v-list-item-icon class="ma-0">
          <v-img
            src="@/assets/ehicond.png"
            contain
            height="25px"
            max-width="25px"
            class="my-2 ml-2 pa-0"
            @click="drawerShow = !drawerShow"
          ></v-img>
        </v-list-item-icon>
      </v-list-item>
      <v-divider></v-divider>
    </template>
    <ehc-menu
      :items="menuItems"
      @syncPropertyCardViews="syncPropertyCardViews"
      @sendWelcomeEmailPreview="sendWelcomeEmailPreview"
    ></ehc-menu>
    <template #append>
      <ehc-menu
        :items="logoutMenu"
        @logout="$store.dispatch('logout')"
      ></ehc-menu>
    </template>
  </v-navigation-drawer>
</template>

<script>
import firebase from "firebase";
import { resolveTrainingVideos } from "@/utils/trainingVideos";

export default {
  data() {
    return {
      syncingCardViews: false,
      logoutMenu: [
        {
          type: "link",
          label: "Logout",
          iconURL: require("@/assets/icons/logout@3x.svg"),
          emitClick: "logout",
        },
      ],
    };
  },
  methods: {
    async sendWelcomeEmailPreview() {
      const confirmed = window.confirm(
        "Send welcome-email preview to tomavey@outlook.com?",
      );
      if (!confirmed) {
        return;
      }
      try {
        const videos = resolveTrainingVideos(this.$store.getters.appSettings || {});
        const setupLink = videos.setupUrl
          ? `<li><a href="${videos.setupUrl}">Set up your guidebook</a></li>`
          : "";
        const customizeLink = videos.customizeUrl
          ? `<li><a href="${videos.customizeUrl}">Customize your guide content</a></li>`
          : "";
        const videoSection =
          setupLink || customizeLink
            ? `<p><strong>Get started with these training videos:</strong></p>
                <ul>${setupLink}${customizeLink}</ul>
                <p>Or visit <a href="https://manage.everhost.io/support/how-to-videos">How-To Videos</a> for more training.</p>`
            : "";

        const previewHtml = `<p class="displayName">Hi Preview User,</p>
                <p>Thank you for joining the Everhost community. Here is your account information:</p>
                https://manage.everhost.io<br/>
                u: preview.user@everhost.io<br/>
                p: ***********<br/><br/>
                ${videoSection}
                <p>Excited to see some amazing property welcome books! We're always looking to hear from our users.  Don't hesitate to contact support@everhost.io with your feedback.</p>
                <p>Cheers,<br/>
                Everhost Support</p>`;

        await firebase.firestore().collection("emails").add({
          to: [{ email: "tomavey@outlook.com", name: "Tom Avey" }],
          from: { email: "support@everhost.io" },
          reply_to: { email: "support@everhost.io" },
          subject: "Welcome Email Preview",
          html: `
            <html>
              <body>
                <p><strong>Preview generated:</strong> ${new Date().toISOString()}</p>
                ${previewHtml}
              </body>
            </html>
          `,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          sent: false,
        });
        this.$store.commit("setAlert", {
          show: true,
          type: "success",
          message: "Welcome email preview sent to tomavey@outlook.com.",
        });
      } catch (error) {
        const code = error?.code ? ` (${error.code})` : "";
        this.$store.commit("setAlert", {
          show: true,
          type: "error",
          message: `Could not send welcome preview${code}: ${error?.message || "Unknown error"}`,
        });
      }
    },
    async syncPropertyCardViews() {
      if (this.syncingCardViews) {
        return;
      }
      const confirmed = window.confirm(
        "Sync all propertyCardViews from properties?\n\nThis creates, updates, or deletes card-view docs so organization property lists stay in sync.",
      );
      if (!confirmed) {
        return;
      }

      this.syncingCardViews = true;
      this.drawerShow = false;
      this.$store.commit("setAlert", {
        show: true,
        type: "info",
        message: "Syncing property card views...",
      });

      try {
        const callable = firebase
          .functions()
          .httpsCallable("migratePropertyCardViews", { timeout: 120000 });
        let resumeAfter = null;
        const totals = {
          scanned: 0,
          viewsCreated: 0,
          viewsUpdated: 0,
          viewsDeleted: 0,
          unchanged: 0,
          errors: 0,
        };

        do {
          const response = await callable({
            dryRun: false,
            startAfterPropertyId: resumeAfter,
          });
          const summary = response?.data?.summary || {};
          totals.scanned += summary.scanned || 0;
          totals.viewsCreated += summary.viewsCreated || 0;
          totals.viewsUpdated += summary.viewsUpdated || 0;
          totals.viewsDeleted += summary.viewsDeleted || 0;
          totals.unchanged += summary.unchanged || 0;
          totals.errors += summary.errors || 0;
          resumeAfter =
            summary.hasMore === true ? summary.resumeAfterPropertyId : null;
        } while (resumeAfter);

        this.$store.commit("setAlert", {
          show: true,
          type: "success",
          message: `Card views synced. Created ${totals.viewsCreated}, updated ${totals.viewsUpdated}, deleted ${totals.viewsDeleted} (scanned ${totals.scanned}).`,
        });
      } catch (error) {
        this.$store.commit("setAlert", {
          show: true,
          type: "error",
          message: `Card view sync failed: ${error?.message || "Unknown error"}`,
        });
      } finally {
        this.syncingCardViews = false;
      }
    },
  },
  computed: {
    menuItems() {
      const basicItems = [
        {
          type: "link",
          label: "Properties",
          iconURL: require("@/assets/icons/Properties -normal@3x.svg"),
          route: "/",
        },
        {
          type: "link",
          label: "Guest Data",
          iconURL: require("@/assets/icons/User Data -normal@3x.svg"),
          route: "/guestdata",
        },
        {
          type: "link",
          label: "Support",
          iconURL: require("@/assets/icons/Support -normal@3x.svg"),
          route: "/support",
        },
        {
          type: "link",
          label: "How-To's",
          icon: "mdi-youtube",
          route: "/support/how-to-videos",
        },
        {
          type: "link",
          label: "Subscribe",
          icon: "mdi-cash-lock-open",
          route: "/premium",
        },
      ];

      if (!this.gcvOrgIsPro) {
        basicItems.push({
          type: "link",
          label: "Upgrade",
          icon: "mdi-star-circle-outline",
          route: "/upgrade",
        });
      }

      let adminItems = this.userHasPermission(
        ["superAdmin"],
        [
          { type: "subheader", label: "Admin Links" },
          { type: "divider" },
          {
            type: "group",
            label: "Accounts",
            icon: "mdi-account-multiple-outline",
            children: [
              {
                type: "link",
                label: "Users",
                iconURL: require("@/assets/icons/2 User@3x.svg"),
                route: "/users",
              },
              {
                type: "link",
                label: "Organizations",
                iconURL: require("@/assets/icons/Home@3xplain.svg"),
                route: "/organizations",
              },
              {
                type: "link",
                label: "My Organization",
                iconURL: require("@/assets/icons/Home@3xplain.svg"),
                route: `/organization/${this.gcvOrgId}`,
              },
              {
                type: "link",
                label: "Feedbacks",
                iconURL: require("@/assets/icons/Support-outline@3x.svg"),
                route: "/feedbacks",
              },
            ],
          },
          {
            type: "group",
            label: "Content",
            icon: "mdi-folder-multiple-outline",
            children: [
              {
                type: "link",
                label: "All Properties",
                iconURL: require("@/assets/icons/Properties -normal@3x.svg"),
                route: "/allProperties",
              },
              {
                type: "link",
                label: "Backgrounds",
                iconURL: require("@/assets/icons/location@3x-plain.svg"),
                route: "/backgroundImages",
              },
              {
                type: "link",
                label: "Templates",
                icon: "mdi-file-document-multiple-outline",
                route: "/templates",
              },
              {
                type: "link",
                label: "Storage Images",
                icon: "mdi-image-multiple",
                route: "/storage-images",
              },
            ],
          },
          {
            type: "group",
            label: "Mail",
            icon: "mdi-email-outline",
            children: [
              {
                type: "link",
                label: "Reactivation Promo",
                icon: "mdi-email-outline",
                route: "/admin/reactivation-promo",
              },
              {
                type: "link",
                label: "Send Welcome Preview",
                icon: "mdi-email-fast-outline",
                emitClick: "sendWelcomeEmailPreview",
              },
            ],
          },
          {
            type: "group",
            label: "Analytics",
            icon: "mdi-poll",
            children: [
              {
                type: "link",
                label: "Advanced",
                icon: "mdi-chart-timeline-variant",
                route: "/advancedanalytics",
              },
              {
                type: "link",
                label: "API",
                icon: "mdi-api",
                route: "/analytics_api",
              },
              {
                type: "link",
                label: "Legacy",
                icon: "mdi-chart-bar",
                route: "/analytics",
              },
            ],
          },
          {
            type: "group",
            label: "Tools",
            icon: "mdi-wrench-outline",
            children: [
              {
                type: "link",
                label: "Settings",
                icon: "mdi-cog-outline",
                route: "/adminSettings",
              },
              {
                type: "link",
                label: "Updates Log",
                iconURL: require("@/assets/icons/clock@3x.svg"),
                route: "/updateslog",
              },
              {
                type: "link",
                label: "Dev Tasks",
                icon: "mdi-format-list-checks",
                route: "/tasks",
              },
              {
                type: "link",
                label: "Sync Card Views",
                icon: "mdi-database-sync-outline",
                emitClick: "syncPropertyCardViews",
              },
            ],
          },
        ],
        [],
      );

      return [...basicItems, ...adminItems];
    },
    drawerShow: {
      get() {
        return this.$store.getters.drawer.show;
      },
      set(val) {
        this.$store.commit("setDrawer", { show: val });
      },
    },
  },
};
</script>

<style>
.ehc-nav-drawer .v-list-item__title {
  font-family: "Sailec";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #1d3557;
}
</style>
